import App from './components/App';
import './style';

export default App;
